<template>
    <div class="input-wrapper">
        <input
            :class="['text-input', value && 'filled']"
            :name="name"
            :id="name"
            ref="inputField"
            :label="label"
            @blur="format"
            @change="handleChange"
            minlength="10"
            type="tel"
            v-maska
            :data-maska="maskDate"
            data-maska-tokens="Y:[1-2]"
            v-model="value"
        />

        <FloatingLabel :label="formatLabel || label || displayName" />

        <div class="error" v-if="displayErrorMessage">{{ displayErrorMessage }}</div>
    </div>
</template>

<script>
import { useField } from 'vee-validate'
import { useStore } from 'vuex'

// lodash components
import padStart from 'lodash/padStart'
import split from 'lodash/split'
import _get from 'lodash/get'

export default {
    props: ['ageMin', 'customErrorMessage', 'formatLabel', 'label', 'name', 'vuexKey'],
    data() {
        return {
            maskDate: '##/##/Y###',
        }
    },
    setup(props) {
        const store = useStore()
        const { errorMessage, handleChange, resetField } = useField(props.name, {
            required: true,
            validDate: true,
            dobBetween: {
                min: props.ageMin,
            },
        })

        return {
            errorMessage,
            handleChange,
            resetField,
            store,
        }
    },
    mounted() {
        this.resetField({
            value: this.value,
        })
    },
    computed: {
        value: {
            get() {
                return this.store.getters.fieldValue(this.name, this.vuexKey || 'data', !!this.vuexKey)
            },
            set(value) {
                value = process.env.TERRITORY !== 'usa' ? this.processDate(value) : this.processUsaFormatDate(value)

                if (this.vuexKey) {
                    this.store.commit('setDataFieldValue', {
                        name: this.name,
                        value: value,
                        key: this.vuexKey,
                    })
                } else {
                    this.store.dispatch('setFieldValue', {
                        name: this.name,
                        value: value,
                    })
                }
            },
        },
        displayName: function () {
            return this.label || this.titleCase(this.name)
        },
        serverError() {
            return this.store.getters.fieldServerError(this.name)
        },
        displayErrorMessage() {
            return this.errorMessage ? this.customErrorMessage || this.errorMessage : this.serverError
        },
    },
    methods: {
        processUsaFormatDate: function (date) {
            if (date.length === 1 && date >= 2) {
                date = `0${date}`
            }

            if (date.length === 4) {
                const month = date.substring(0, 3)
                const day = date.substring(3)

                if (day >= 4) {
                    date = `${month}0${day}`
                }
            }

            return date
        },
        processDate: function (date) {
            if (date.length === 1 && date >= 4) {
                date = `0${date}`
            }

            if (date.length === 4) {
                const month = date.substring(3)
                const day = date.substring(0, 3)

                if (month >= 2) {
                    date = `${day}0${month}`
                }
            }

            return date
        },
        format: function () {
            if (!this.value) {
                return
            }

            const dayMonthYear = split(this.value, '/')

            const day =
                process.env.TERRITORY !== 'usa' ? padStart(dayMonthYear[0], 2, 0) : padStart(dayMonthYear[1], 2, 0)
            const month =
                process.env.TERRITORY !== 'usa' ? padStart(dayMonthYear[1], 2, 0) : padStart(dayMonthYear[0], 2, 0)
            const year = padStart(dayMonthYear[2], 4, 0)

            this.value = process.env.TERRITORY !== 'usa' ? `${day}/${month}/${year}` : `${month}/${day}/${year}`
        },
        focus() {
            this.autoFocus(this.$refs.inputField)
        },
    },
    watch: {
        value(newValue) {
            switch (newValue?.charAt(6)) {
                case '1':
                    this.maskDate = '##/##/Y9##'
                    break

                case '2':
                    this.maskDate = '##/##/Y0##'
                    break

                default:
                    this.maskDate = '##/##/Y###'
            }
        },
    },
}
</script>
